/**
 * Drops n elements from the beginning of an array
 */
export const drop = <T>(array: T[], n: number): T[] => {
  return array.slice(Math.max(0, n))
}
